import { HttpClient, HttpParams, HttpErrorResponse, HttpEventType, HttpEvent, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { EventPlace, WebFamEvent } from '../models/event.model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UploadStatus } from '../models/common.model';

@Injectable()
export class EventService {

    constructor(private httpClient: HttpClient) { }

    uploadFileEvent(fileData: FormData, eventId: string) {
        console.log('uploadEvent');
        return this.httpClient.post<UploadStatus>(`${environment.backendUrl}/event/upload/tree/${environment.currentTree}/event/${eventId}`,
            fileData, { reportProgress: true, observe: 'events' }).pipe(map(event => this.getEventMessage(event, fileData)),
                catchError(this.handleError)
            );
    }

    uploadReplaceFileEvent(fileData: FormData, eventId: string, fileId: string) {
        console.log('uploadReplaceEvent');
        return this.httpClient.post<UploadStatus>(
            `${environment.backendUrl}/event/upload_replace/tree/${environment.currentTree}/event/${eventId}/file/${fileId}`,
            fileData, { reportProgress: true, observe: 'events' }).pipe(map(event => this.getEventMessage(event, fileData)),
                catchError(this.handleError)
            );
    }

    insertEvent(data: WebFamEvent) {
        return this.httpClient.post<WebFamEvent>(environment.backendUrl + '/event/insert/tree/' + environment.currentTree, { data });
    }

    updateEvent(data: WebFamEvent) {
        return this.httpClient.patch<WebFamEvent>(environment.backendUrl + '/event/update/tree/' + environment.currentTree, { data });
    }

    // insert/update/remove list
    updateEventList(data: WebFamEvent[]) {
        return this.httpClient.patch<string>(environment.backendUrl + '/event/list/tree/' + environment.currentTree, { data });
    }

    getEvent(id: string) {
        return this.httpClient.get<WebFamEvent>(environment.backendUrl + '/event/get/tree/' + environment.currentTree + '/event/' + id);
    }

    deleteDictionaryEvent(id: string) {
        return this.httpClient.delete(environment.backendUrl + '/event/remove/dictionary/tree/' + environment.currentTree + '/event/' + id);
    }

    getPlaceList(place: string) {
        let params = new HttpParams();
        params = params.append('skip', '0');
        params = params.append('limit', '5');

        return this.httpClient.get<EventPlace[]>(
            environment.backendUrl + '/event/list/top/tree/' + environment.currentTree + '/place/' + place,
            { params }
        );
    }

    getEventListByType(event: string, eventType: string) {
        let params = new HttpParams();
        params = params.append('skip', '0');
        params = params.append('limit', '5');
        params = params.append('event_type', eventType);
        // Add cache buster to prevent HTTP caching
        params = params.append('_t', Date.now().toString());

        return this.httpClient.get<WebFamEvent[]>(
            environment.backendUrl + '/event/list/tree/' + environment.currentTree + '/type/' + event,
            { params }
        );
    }

    private getEventMessage(event: HttpEvent<unknown>, _formData: FormData) {
        switch (event.type) {
            case HttpEventType.UploadProgress:
                return this.fileUploadProgress(event);
            case HttpEventType.Response:
                return this.apiResponse(event);
        }
        return undefined;
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened. Please try again later.');
    }

    private fileUploadProgress(event: HttpProgressEvent) {
        const percentDone = Math.round(100 * event.loaded / (event.total ? event.total : 0));
        return { status: 'progress', message: percentDone };
    }

    private apiResponse(event: HttpResponse<unknown>) {
        return event.body;
    }

}
